class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    
    // Check if this is the header search modal
    this.isHeaderSearch = this.classList.contains('header__search');

    this.detailsContainer.addEventListener('keyup', (event) => {
      // Don't close header search on Escape
      if (event.code.toUpperCase() === 'ESCAPE' && !this.isHeaderSearch) {
        this.close();
      }
    });
    
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    
    const closeButton = this.querySelector('button[type="button"]');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
    
    // Ensure header search stays open
    if (this.isHeaderSearch) {
      this.ensureHeaderSearchOpen();
    }
  }
  
  ensureHeaderSearchOpen() {
    // Use MutationObserver to prevent the header search from being closed
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (!this.detailsContainer.hasAttribute('open')) {
            this.detailsContainer.setAttribute('open', 'true');
          }
        }
      });
    });
    
    observer.observe(this.detailsContainer, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    // Don't allow closing header search
    if (this.isHeaderSearch) {
      return;
    }
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    // Don't close header search on body click
    if (this.isHeaderSearch) {
      return;
    }
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    // Don't allow closing header search
    if (this.isHeaderSearch) {
      return;
    }
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
